import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { VerticalLayout } from "@lib/titan2/dist/game/control/layout/VerticalLayout";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { PanelProperties } from "@lib/titan2/dist/game/control/properties/PanelProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import * as PIXI from "pixi.js";
import { SlingoLang } from "../lang/SlingoLang";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractPayTableScatterProperties.ts
 */
export class AbstractPayTableScatterProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.titleFieldProperties.equals(other.titleFieldProperties) &&
            this.valueFieldProperties.equals(other.valueFieldProperties);
    }
    setDefaultValues() {
        this.backgroundProperties = new SpriteProperties(SlingoStyle.PAY_TABLE_SCATTER, SlingoStyle.MODULE, new PIXI.Point(0, 0));
        this.titleFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_SCATTER, new PIXI.Point(320, 30), SlingoLang.SCATTER_6, ControlConstants.CENTER);
        this.titleFieldProperties.size = new PIXI.Point(168, 50);
        this.valueFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_SCATTER, new PIXI.Point(320, 70), null, ControlConstants.CENTER);
        this.valueFieldProperties.size = new PIXI.Point(175, 50);
    }
}
/**
 * AbstractPayTableCellProperties.ts
 */
export class AbstractPayTableCellProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.effectsProperties.equals(other.effectsProperties) &&
            (this.iconProperties ? this.iconProperties.equals(other.iconProperties) : this.iconProperties === other.iconProperties) &&
            this.inactiveLabelProperties.equals(other.inactiveLabelProperties) &&
            this.inactiveFieldProperties.equals(other.inactiveFieldProperties) &&
            this.inactiveOrFieldProperties.equals(other.inactiveOrFieldProperties) &&
            this.inactiveAltFieldProperties.equals(other.inactiveAltFieldProperties) &&
            this.activeLabelProperties.equals(other.activeLabelProperties) &&
            this.activeFieldProperties.equals(other.activeFieldProperties) &&
            this.activeOrFieldProperties.equals(other.activeOrFieldProperties) &&
            this.activeAltFieldProperties.equals(other.activeAltFieldProperties) &&
            this.highlightFieldProperties.equals(other.highlightFieldProperties) &&
            this.highlightOrFieldProperties.equals(other.highlightOrFieldProperties) &&
            this.highlightAltFieldProperties.equals(other.highlightAltFieldProperties) &&
            (this.useShortLabel === other.useShortLabel);
    }
    setDefaultValues() {
        let effectNames = new Dictionary();
        effectNames.setValue("1", "ladder_1_noWin");
        effectNames.setValue("2", "ladder_2_noWin");
        effectNames.setValue("3", "ladder_3_win");
        effectNames.setValue("4", "ladder_4_win");
        effectNames.setValue("5", "ladder_5_win");
        effectNames.setValue("6", "ladder_6_win");
        effectNames.setValue("7", "ladder_7_win");
        effectNames.setValue("8", "ladder_8_featureWin");
        effectNames.setValue("9", "ladder_9_featureWin");
        effectNames.setValue("10", "ladder_10_featureWin");
        effectNames.setValue("11", "ladder_11_featureWin");
        this.id = this.id || "11";
        this.labelPos = this.labelPos || new PIXI.Point(30, 0);
        this.fieldPos = this.fieldPos || new PIXI.Point(270, 0);
        this.altFieldPos = this.altFieldPos || new PIXI.Point(470, 0);
        this.labelSize = this.labelSize || new PIXI.Point(168, 77);
        this.fieldSize = this.fieldSize || new PIXI.Point(175, 77);
        this.altFieldSize = this.altFieldSize || new PIXI.Point(175, 77);
        this.orientation = this.orientation || "landscape";
        this.active = `ladder_${this.orientation}_field${this.id}_active`;
        this.activeEffect = effectNames.getValue(this.id);
        this.off = `ladder_${this.orientation}_field${this.id}_off`;
        this.useShortLabel = false;
        this.backgroundProperties = new SpineProperties(SlingoStyle.PAY_TABLE_CELL, SlingoStyle.MODULE);
        this.effectsProperties = new SpineProperties(SlingoStyle.PAY_TABLE_CELL, SlingoStyle.MODULE);
        //this.iconProperties = new SpriteProperties(SlingoStyle.PAY_TABLE_ICON, SlingoStyle.MODULE);
        this.inactiveLabelProperties = new TextFieldProperties(FontStyle.PAY_TABLE_CELL, this.labelPos, null, ControlConstants.LEFT, ControlConstants.CENTER, this.labelSize);
        this.activeLabelProperties = new TextFieldProperties(FontStyle.PAY_TABLE_CELL, this.labelPos, null, ControlConstants.LEFT, ControlConstants.CENTER, this.labelSize);
        this.inactiveFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_CELL, this.fieldPos, null, ControlConstants.RIGHT, ControlConstants.CENTER, this.fieldSize);
        this.inactiveOrFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_CELL, this.fieldPos, null, ControlConstants.CENTER, ControlConstants.CENTER, this.fieldSize);
        this.inactiveAltFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_CELL, this.altFieldPos, null, ControlConstants.RIGHT, ControlConstants.CENTER, this.fieldSize);
        this.activeFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_CELL, this.fieldPos, null, ControlConstants.RIGHT, ControlConstants.CENTER, this.fieldSize);
        this.activeOrFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_CELL, this.fieldPos, null, ControlConstants.CENTER, ControlConstants.CENTER, this.fieldSize);
        this.activeAltFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_CELL, this.altFieldPos, null, ControlConstants.RIGHT, ControlConstants.CENTER, this.fieldSize);
        this.highlightFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_CELL, this.fieldPos, null, ControlConstants.RIGHT, ControlConstants.CENTER, this.fieldSize);
        this.highlightOrFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_CELL, this.fieldPos, null, ControlConstants.CENTER, ControlConstants.CENTER, this.fieldSize);
        this.highlightAltFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_CELL, this.altFieldPos, null, ControlConstants.RIGHT, ControlConstants.CENTER, this.fieldSize);
    }
    reInitialiseFieldProperties() {
        this.inactiveLabelProperties.position.set(this.labelPos.x, this.labelPos.y);
        this.inactiveLabelProperties.size.set(this.labelSize.x, this.labelSize.y);
        this.activeLabelProperties.position.set(this.labelPos.x, this.labelPos.y);
        this.activeLabelProperties.size.set(this.labelSize.x, this.labelSize.y);
        this.inactiveFieldProperties.position.set(this.fieldPos.x, this.fieldPos.y);
        this.inactiveFieldProperties.size.set(this.fieldSize.x, this.fieldSize.y);
        this.inactiveOrFieldProperties.position.set(this.fieldPos.x, this.fieldPos.y);
        this.inactiveOrFieldProperties.size.set(this.fieldSize.x, this.fieldSize.y);
        this.inactiveAltFieldProperties.position.set(this.altFieldPos.x, this.altFieldPos.y);
        this.inactiveAltFieldProperties.size.set(this.fieldSize.x, this.fieldSize.y);
        this.activeFieldProperties.position.set(this.fieldPos.x, this.fieldPos.y);
        this.activeFieldProperties.size.set(this.fieldSize.x, this.fieldSize.y);
        this.activeOrFieldProperties.position.set(this.fieldPos.x, this.fieldPos.y);
        this.activeOrFieldProperties.size.set(this.fieldSize.x, this.fieldSize.y);
        this.activeAltFieldProperties.position.set(this.altFieldPos.x, this.altFieldPos.y);
        this.activeAltFieldProperties.size.set(this.fieldSize.x, this.fieldSize.y);
        this.highlightFieldProperties.position.set(this.fieldPos.x, this.fieldPos.y);
        this.highlightFieldProperties.size.set(this.fieldSize.x, this.fieldSize.y);
        this.highlightOrFieldProperties.position.set(this.fieldPos.x, this.fieldPos.y);
        this.highlightOrFieldProperties.size.set(this.fieldSize.x, this.fieldSize.y);
        this.highlightAltFieldProperties.position.set(this.altFieldPos.x, this.altFieldPos.y);
        this.highlightAltFieldProperties.size.set(this.fieldSize.x, this.fieldSize.y);
    }
}
/**
 * AbstractPayTableProperties.ts
 */
export class AbstractPayTableProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.scatterProperties.equals(other.scatterProperties) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.frameProperties.equals(other.frameProperties) &&
            this.panelProperties.equals(other.panelProperties) &&
            this.cellProperties.every((props, index) => props.equals(other.cellProperties[index])) &&
            this.backToGameButtonProperties.equals(other.backToGameButtonProperties) &&
            (this.matchedPatternInterval === other.matchedPatternInterval) &&
            (this.landscapePrimary === other.landscapePrimary) &&
            (this.portraitPrimary === other.portraitPrimary) &&
            this.ornamentBackgroundProperties.equals(other.ornamentBackgroundProperties) &&
            this.ornamentDiamondProperties.equals(other.ornamentDiamondProperties);
    }
    setDefaultValues() {
        this.backgroundProperties = new SpriteProperties(SlingoStyle.PAY_TABLE_BACKGROUND, SlingoStyle.MODULE, new PIXI.Point(0, 0));
        this.frameProperties = new SpriteProperties(SlingoStyle.PAY_TABLE_FRAME, SlingoStyle.MODULE, new PIXI.Point(0, 0));
        this.panelProperties = new PanelProperties(new PIXI.Point(0, 0));
        this.panelProperties.layout = new VerticalLayout(0);
        this.landscapePrimary = false;
        this.portraitPrimary = false;
        this.backToGameButtonProperties = new ButtonProperties(SlingoStyle.BACK_TO_GAME_BUTTON, SlingoStyle.MODULE);
        //this.backToGameButtonProperties.textFieldProperties = new TextFieldProperties(FontStyle.START_GAME_BUTTON, null, SlingoLang.BACK_TO_GAME_BUTTON, ControlConstants.CENTER);
        this.matchedPatternInterval = 500;
    }
}
//# sourceMappingURL=AbstractPayTableProperties.js.map